import Vue from "vue";
import VueRouter from "vue-router";
import { Search, messages, fallbackLocale } from "@eset/search";
import VueI18n from "vue-i18n";
import VueCompositionAPI from "@vue/composition-api";

let langCode = "en-uk";

const urlPath = window.location.pathname.substr(1).split("/");

if (urlPath.length >= 1) {
    langCode = urlPath.shift();
}

Vue.use(VueCompositionAPI);
Vue.use(VueI18n);
Vue.use(VueRouter);

Vue.use(Search, {
    searchParam: "term",
    inputTimeout: 300,
    itemsPerPage: 9,
    searchUrl: `${process.env.SEARCH_PUBLIC_URL}/${process.env.SEARCH_INDEX}/_search`,
    hidePaginationOnOnePageResults: true,
    itemsInSearchbar: 5,
    filterParameters: () => [{ "language.keyword": langCode }],
    sortResults: false,
    actionUrl: `${window.location.origin}/${langCode}/search`,
});

const i18n = new VueI18n({
    locale: langCode,
    fallbackLocale,
    messages,
});
const router = new VueRouter({
    mode: "history",
});

new Vue({
    router,
    i18n,
    el: "#app",
});
